import { PayloadAction } from '@reduxjs/toolkit';

import {
    CqmCapabilityClient,
    CqmCapabilityDto,
    CqmEnablementRequestDto,
} from '@medone/medonehp-api-client';

import { handleError } from '../../../../shared/common/HandleErrors';
import { Axios } from '../../../../shared/common/http';
import { AppDispatch, AppThunk, RootState } from '../../../../shared/store';
import { AdminState } from './models';

// Action-type constants resolved statically so the thunks below don't depend on
// adminSlice.actions resolution order at module load (jest hits the slice cycle
// before adminSlice is fully created; production hits it after).
const SET_CQM_CAPABILITY = 'admin/setCqmCapability';
const SET_ERROR = 'admin/setError';

export const reducers = {
    setCqmCapability: (state: AdminState, action: PayloadAction<CqmCapabilityDto>) => {
        state.cqmCapability = action.payload;
        state.errorMessage = null;
    },
};

export function fetchCqmCapability(): AppThunk {
    return async (dispatch: AppDispatch) => {
        const client = new CqmCapabilityClient(null, Axios);

        try {
            const response = await client.getCapability();

            if (response.result.succeeded) {
                dispatch({ type: SET_CQM_CAPABILITY, payload: response.result.entity });
            } else {
                handleError(response, () => dispatch({ type: SET_ERROR, payload: null }));
            }
        } catch (error) {
            handleError(error, () => dispatch({ type: SET_ERROR, payload: error.toString() }));
        }
    };
}

export function setCqmEnablement(enabled: boolean): AppThunk<Promise<boolean>> {
    return async (dispatch: AppDispatch) => {
        const client = new CqmCapabilityClient(null, Axios);

        try {
            const dto = new CqmEnablementRequestDto();
            dto.enabled = enabled;

            const response = await client.setEnablement(dto);

            if (response.result.succeeded) {
                dispatch({ type: SET_CQM_CAPABILITY, payload: response.result.entity });
            } else {
                handleError(response, () => dispatch({ type: SET_ERROR, payload: null }));
            }

            return response.result.succeeded;
        } catch (error) {
            handleError(error, () => dispatch({ type: SET_ERROR, payload: error.toString() }));
        }

        return false;
    };
}

export const selectCqmCapability = (state: RootState) => state.admin.cqmCapability;
